<template>
  <div class="auth-wrapper auth-v2">
    <div class="w-100 d-flex flex-column justify-content-between">
      <div class="px-2">
        <HeaderBar/>
        <div
          class="d-flex flex-column mb-2 mt-4"
          style="font-size: 15px; font-weight: 500"
        >
          <v-offline 
          online-class="online"
          offline-class="offline"
          @detected-condition="onConnectionChange">
              <template v-if="online">
              <div class="flex w-full h-full justify-center items-center text-6xl">
                  
              </div>
              </template>
              <template v-if="!online">
              <div class="flex w-full h-full justify-center items-center text-6xl">
              Sin Conexión
              </div>
              </template>
          </v-offline>
          <div class="add-economic-record-title1 mt-2 text-center">Nuevo Animal (Compra)</div>
          
        </div>
        <validation-observer ref="GanForm">
          <b-form @submit.prevent="" >
          <div class="d-flex align-items-center justify-content-center">
            <div class="flex-column pt-0 mr-2">Macho</div>
            <div class="align-self-end mr-2">
              <b-form-radio
                v-model="animal.sex"
                button-variant="#D7B92C"
                value="0"
                class=""
                name="check-button"
              />
            </div>
            <div class="flex-column">Hembra</div>
            <div class="align-self-end mr-2">
              <b-form-radio
                v-model="animal.sex"
                button-variant="#D7B92C"
                value="1"
                class=""
                name="check-button"
              />
              
            </div>
          </div>
          <b-form-group label="Nombre" label-for="name">
            <validation-provider
              #default="{ errors }"
              name="Nombre"
              rules="required"
            >
              <b-form-input id="name" v-model="animal.name" />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <div class="d-flex">
            <b-form-group label="Número" label-for="number" class="mr-1">
              <validation-provider
                #default="{ errors }"
                name="Número"
                rules="required"
              >
                <b-form-input id="number" ref="animalNumber" type="number" v-model="animal.number" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
<!--             <b-form-group label="SIRIGABB" label-for="sirigapp">
              <validation-provider
                #default="{ errors }"
                name="SIRIGABB"
                :rules="{regex: '^([0-9]{7})$'}"
              >
                <b-form-input id="sirigapp" v-model="animal.sirigapp" @focus="sirigabbSelector"/>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group> -->
          </div>
          <b-modal size="sm" centered v-model="modalShow" hide-footer hide-header>
              <div>
                  <div class="d-flex justify-content-center mt-1 mb-2 text-justify">
                      <h3>Introduzca los 7 números reflejados en la etiqueta del animal.</h3>
                  </div>
                  <div class="d-flex justify-content-center mt-1 mb-2 text-center">
                      <img src="@/assets/images/ganImage/SIRIGABB.png"  width="350" alt="">
                  </div>
                  <validation-provider
                    #default="{ errors }"
                    name="SIRIGABB"
                    :rules="{regex: '^([0-9]{7})$'}"
                  >
                    <b-form-input id="sirigapp" v-model="animal.sirigapp"/>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                  <div class="d-flex justify-content-center mt-1 mb-2 text-justify">
                    <b-button @click="modalShow=false" class="bg-primary w-75 mt-2 " block>
                      Aceptar
                    </b-button>
                  </div>
                  
              </div>
          </b-modal> 
          <b-form-group>
            <div class="d-flex">
              <div class="mr-1">
                <b-form-radio
                  v-model="selected"
                  name="some-radios"
                  value=""
                  >Nacimiento(Mes/Año)
                </b-form-radio>
                <month-picker-input 
                  :no-default="true" 
                  :lang="setLang" 
                  :date-format="dateFormat" 
                  :max-date="maxCfgDate"
                  v-model="bornDate" @input="dateSelected"/>
              </div>
              <div>
                <b-form-radio
                  v-model="selected"
                  name="some-radios"
                  >Edad Aprox:</b-form-radio
                >
                <b-form-input type="number" v-model="animalAge" @input="setAge"/>
              </div>
            </div>
          </b-form-group>
          <div class="d-flex">
            <b-form-group label="Madre" label-for="madre" class="mr-1">
              <validationProvider
                #default="{ errors }"
                name="Madre"
              >
                <b-form-input id="madre" name="madre" v-model="animal.mother" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validationProvider>
            </b-form-group>
            <b-form-group label="Padre" label-for="padre">
              <validationProvider
                #default="{ errors }"
                name="Padre"
              >
                <b-form-input id="padre" name="padre" v-model="animal.father" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validationProvider>
            </b-form-group>
          </div>
          <div class="d-flex">
            <b-form-group
              label="Valor de compra"
              label-for="madre"
              class="mr-1"
            >
              <validationProvider
                #default="{ errors }"
                name="Valor de compra"
                rules="required"
              >
                <b-form-input id="price" name="price" v-model="animal.price" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validationProvider>
            </b-form-group>
            <b-form-group label="Peso" label-for="weight">
              <validationProvider
                #default="{ errors }"
                name="Peso"
                rules="required"
              >
                <b-form-input id="weight" name="weight" v-model="animal.weight"  type="number" min="0" max="2000" onkeyup="if(value>2000) value=2000;"/>
                <small class="text-danger">{{ errors[0] }}</small>
              </validationProvider>
            </b-form-group>
          </div>
          <div class="d-flex">
            <b-form-group
              label="Fecha de compra"
              label-for="fecha_compra"
              class="mr-1 flex-fill"
            >
              <validationProvider
                #default="{ errors }"
                name="fecha_compra"
                rules="required"
              >
                <b-form-datepicker id="fecha_compra" name="fecha_compra" v-model="animal.buy_date" 
                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                :min="minCfgDate" :max="maxCfgDate"
                locale="es-ES"/>
                <small class="text-danger">{{ errors[0] }}</small>
              </validationProvider>
            </b-form-group>
            <b-form-group label="Raza (opcional):" label-for="race" 
              class="">
                <b-form-select id="race" v-model="animal.batch_id" :options="raceOptions" :value="raceOptions.value" />
            </b-form-group>
          </div>
      
        <div class="row justify-content-center text-center align-items-center ">
          <div class=" col-12">
            <span>Subir archivo </span>
            <span> o foto</span>
          </div>
         <div>
          <div class="col-12">
            <b-img :src="featured" @click="uploadImage" :width="imgWidth"></b-img>
            <b-form-file 
              ref="FileUpload"
              v-model="fileU" style="display: none;"
              accept="image/jpeg, image/png"
              plain/>
          </div>
        </div>
        </div> 
        <div class="d-flex align-items-center justify-content-center pbbuton">
          <b-button @click="addNewAnimal" class="bg-primary w-75 mt-2 " block :disabled="isPost">Incluir Animal</b-button>
        </div>
             </b-form>
          </validation-observer>
    </div>
    </div>
    
    <ControlMenu />
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BRow,
  BCol,
  BLink,
  BImg,
  BFormFile,
  BFormGroup,
  BForm,
  BButton,
  BFormSelect,
  BFormInput,
  BFormRadio,
  BFormCheckbox,
  BFormDatepicker
} from "bootstrap-vue";
import ControlMenu from "@/components/ControlMenu.vue";
import axios from "axios";
import HeaderBar from '@/components/HeaderBar.vue'
import vSelect from "vue-select"
import { MonthPickerInput } from 'vue-month-picker'
import "vue-select/dist/vue-select.css";
import { required } from "@validations";
import imageFile from "@/assets/images/ganImage/image 177.svg"
import { VOffline } from 'v-offline';

export default {
  components: {
    ValidationProvider,
    vSelect,
    required,
    BFormRadio,
    ValidationObserver,
    BRow,
    BCol,
    BLink,
    BImg,
    BFormFile,
    BForm,
    BButton,
    BFormSelect,
    BFormInput,
    ControlMenu,
    HeaderBar,
    BFormCheckbox,
    BFormRadio,
    BFormGroup,
    BFormDatepicker,
    MonthPickerInput,
    imageFile,
    VOffline
  },
  data() {
    const now = new Date()
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    // 15th two months prior
    const minDate = new Date(today)
    minDate.setMonth(minDate.getMonth() - 500)
    minDate.setDate(15)
    // 15th in two months
    const maxDate = new Date(today)
    maxDate.setMonth
    maxDate.setMonth(maxDate.getMonth())
    maxDate.setDate(maxDate.getDate())
    return {  
      isPost:false,
      online:false,
      modalShow:false,
      selected: false,
      dateFormat:'%n/%Y',
      maxCfgDate:maxDate,
      minCfgDate:minDate,
      setLang:'es',
      raceOptions:[],
      featured:imageFile,
      bornDate:"",
      animalAge:0,
      animal:{
        name:"",
        number:"",
        sirigapp:"",
        weight:0,
        age:0,
        sex:0,
        mother:"",
        dad:"",
        image_url:"",
        image1:"",
        image2:"",
        image3:"",
        birthdate:"",
        buy_date:now,
        farm_id:localStorage.getItem('currentFarm'),
        state:1,
        price:0,
        batch_id:'Otro'
      },
      fileU:null,
      filename:null,
      imgWidth:null,
    };
  },
  methods: {
    async fetchRace(config) {
      if(this.online){
        fetch(this.$apiUrl+"list/animal_batches", config)
        .then(response => response.json())
        .then(result => {
            this.raceOptions = result.animal_batches.map(item => item.name)
        })
      }else{
        this.raceOptions=['Otro']
      }
        
    },
    uploadImage(){
      this.$refs['FileUpload'].$el.click();
    },
    dateSelected(){
      console.log(this.bornDate);
      let nowDate= new Date;
      let newDate= new Date(this.bornDate.year,(this.bornDate.monthIndex-1),1);
      this.animal.birthdate= newDate;
      let age= this.monthDiff(newDate, nowDate);
      this.animal.age= age;
      this.animalAge=age;//parseFloat(age/12).toFixed(2);
      console.log(newDate);
      console.log(age);
    },
    setAge(){
      this.animal.age= this.animalAge;
    },
    monthDiff(d1, d2) {
      let months;
      months = (d2.getFullYear() - d1.getFullYear()) * 12;
      months -= d1.getMonth();
      months += d2.getMonth();
      return months <= 0 ? 0 : months;
    },
    sirigabbSelector(){
      console.log('input')
      this.$refs.animalNumber.focus();
      this.modalShow=true;
    },
    addNewAnimal() {
      this.$refs.GanForm.validate().then(success => {
        if(success){
          this.isPost=true;
          const token = localStorage.getItem("accessToken");
          const config = {headers: {"X-Authorization": `Bearer ${token}`}};
          let self= this;
          if(this.online){
            if(this.fileU!=null){
              let formData=new FormData();
              formData.append('file', this.fileU);
              formData.append('name', this.filename);
              axios.post(this.$fileUpUrl, formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  "X-Authorization": `Bearer ${token}`
                }
              }).then(function(result){
                console.log(result);
                self.animal.image_url='temp__'+result.data.filetoken+'/'+result.data.files.file.name;
                console.log('animal post');
                console.log(self.animal);
                self.$http.post("add/animals", self.animal, config).then(function(resultxx){
                  console.log(resultxx)
                  self.animal={
                    name:"",
                    number:"",
                    sirigapp:"",
                    weight:0,
                    age:0,
                    sex:0,
                    image_url:"",
                    mother:"",
                    father:"",
                    image1:"",
                    image2:"",
                    image3:"",
                    birthdate:"",
                    buy_date:"",
                    state:1,
                    price:0,
                    farm_id:localStorage.getItem('currentFarm'),
                    batch_id:0
                  }
                  self.$swal({
                    title: 'Registro de Animal',
                    text: 'Se insertó animal de manera satisfactoria',
                    type: 'success',
                    icon:'success',
                    showCancelButton: false,
                    confirmButtonColor:'#5E8F23',
                    showCloseButton: true,
                    showLoaderOnConfirm: false  
                  }).then(function(){
                    history.back();
                  });
                }).catch(error => {
                  console.log(error)
                });
              })
            }else{
              self.$http.post("add/animals", self.animal, config).then((result)=>{
                console.log(result);
                self.animal={
                  name:"",
                  number:"",
                  sirigapp:"",
                  weight:0,
                  age:0,
                  sex:0,
                  image_url:"",
                  mother:"",
                  father:"",
                  image1:"",
                  image2:"",
                  image3:"",
                  birthdate:"",
                  buy_date:"",
                  state:0,
                  price:0,
                  farm_id:localStorage.getItem('currentFarm'),
                  batch_id:0
                }
                self.$swal({
                  title: 'Registro de Animal',
                  text: 'Se insertó animal de manera satisfactoria',
                  type: 'success',
                  icon:'success',
                  showCancelButton: false,
                  confirmButtonColor:'#5E8F23',
                  showCloseButton: true,
                  showLoaderOnConfirm: false  
                }).then(function(){
                  history.back();
                });
              }).catch(error => {
                console.log(error)
              });
            }
          }else{
            localStorage.setItem('animalCreate',JSON.stringify(self.animal));
            self.$swal({
              title: 'Registro de Animal',
              text: 'Se insertó animal de manera local, recuerde sincronizar los datos cuando tenga conexión a internet.',
              type: 'success',
              icon:'success',
              showCancelButton: false,
              confirmButtonColor:'#5E8F23',
              showCloseButton: true,
              showLoaderOnConfirm: false  
            }).then(function(){
              history.back();
            });
          }
          
          
        }
      })
    },
    onConnectionChange(val){
      this.online=val;
      console.log(val);
    },
  },
  watch:{
      'fileU':function(value){
        this.imgWidth=200;
        this.filename=value.name;
        this.featured=URL.createObjectURL(this.fileU);
        console.log(value);
      },
  },
  created() {
    const token = localStorage.getItem("accessToken");
    const config = {headers: {"X-Authorization": `Bearer ${token}`}};
    this.online=navigator.onLine;
    this.fetchRace(config);
  }
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";



</style>
